import CrudRepository from './CrudRepository'
export default class HomeSliderRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/websiteSlider/web')
  }
}
